<app-bringoz-data-table [uniqueId]="tableUniqueId"
                        [defaultWidths]="defaultWidths"
                        [items]="visitPlans"
                        [rowHeight]="rowHeight"
                        [resizable]="true"
                        [isLoading]="isLoading"
                        [hideWhenEmpty]="true"
                        (fetchNext)="fetchNext.emit()">

  <ng-template tableHeader>
    <div class="th actions-column"></div>
    <div class="th col-visit-plan-name">
      <span class="text-ellipsis">{{ 'Name' | translate }}</span>
      <ng-container *ngTemplateOutlet="sortButton; context: {$implicit: 'sortName'}"></ng-container>
    </div>
    <div class="th col-template">
      <span class="text-ellipsis">{{ 'Template' | translate }}</span>
      <ng-container *ngTemplateOutlet="sortButton; context: {$implicit: 'sortTemplate'}"></ng-container>
    </div>
    <div class="th col-status">
      <span class="text-ellipsis">{{ 'Status' | translate }}</span>
      <ng-container *ngTemplateOutlet="sortButton; context: {$implicit: 'sortStatus'}"></ng-container>
    </div>
    <div class="th col-dates">
      <span class="text-ellipsis">{{ 'Dates' | translate }}</span>
      <ng-container *ngTemplateOutlet="sortButton; context: {$implicit: 'sortDates'}"></ng-container>
    </div>
    <div class="th col-service-time-provider">
      <span class="text-ellipsis">{{ 'Service Time Provider' | translate }}</span>
      <ng-container *ngTemplateOutlet="sortButton; context: {$implicit: 'sortServiceTimeProvider'}"></ng-container>
    </div>
    <div class="th col-units-provider">
      <span class="text-ellipsis">{{ 'Units Provider' | translate }}</span>
      <ng-container *ngTemplateOutlet="sortButton; context: {$implicit: 'sortUnitsProvider'}"></ng-container>
    </div>
    <div class="th col-delivery-time-provider">
      <span class="text-ellipsis">{{ 'Delivery Time Provider' | translate }}</span>
      <ng-container *ngTemplateOutlet="sortButton; context: {$implicit: 'sortDeliveryTimeProvider'}"></ng-container>
    </div>
    <div class="th col-branches text-ellipsis">{{ 'Branches' | translate }}</div>
    <div class="th col-created-by">
      <span class="text-ellipsis">{{ 'Created By' | translate }}</span>
      <ng-container *ngTemplateOutlet="sortButton; context: {$implicit: 'sortCreatedBy'}"></ng-container>
    </div>
  </ng-template>

  <ng-template #sortButton let-name>
    <bringoz-button type="tertiary"
                    class="sort-button"
                    (onClick)="sortChange.emit(name)">
      <bringoz-icon [iconName]="sortType?.name === name ? asceDescIconsMap[sortType.type] : 'sort'"></bringoz-icon>
    </bringoz-button>
  </ng-template>

  <ng-template tableRow let-visitPlan>
    <div class="tr layout-row layout-align-start-center">

      <!--Actions-->
      <div class="td actions-column layout-row layout-align-center-center">
        <bringoz-button type="tertiary"
                        size="fit"
                        aria-label="Actions"
                        (onClick)="visitPlanActions.emit({visitPlan: visitPlan, event: $event})">
          <bringoz-icon iconName="menu" classSize="lg"></bringoz-icon>
        </bringoz-button>
      </div>

      <!--Name-->
      <div class="td col-visit-plan-name layout-row layout-align-start-center">
        <a class="br-link-1 text-ellipsis"
           [ngbTooltip]="visitPlan.name"
           openDelay="300"
           triggers="hover"
           container="body"
           (click)="goToVisitPlan.emit(visitPlan); $event.stopPropagation()">
          {{ visitPlan.name }}
        </a>
        <app-bringoz-status-tag *ngIf="visitPlan.isArchive"
                                class="margin-left-5"
                                [status]="'DELETED'">
        </app-bringoz-status-tag>
      </div>

      <!--Template-->
      <div class="td col-template layout-row layout-align-start-center">
        <span class="text-ellipsis"
              [ngbTooltip]="visitPlan.schedulingProjectTemplateReference?.name"
              openDelay="300"
              triggers="hover"
              container="body">
          {{ visitPlan.schedulingProjectTemplateReference?.name }}
        </span>
      </div>

      <!--Status-->
      <div class="td col-status layout-row layout-align-start-center">
        <span class="text-ellipsis">{{ 'SCHEDULING_PROJECT_STATUS.' + visitPlan.schedulingProjectStatus | translate }}</span>
      </div>

      <!--Dates-->
      <div class="td col-dates layout-row layout-align-start-center">
        <span class="text-ellipsis"
              [ngbTooltip]="(visitPlan | bringozFullDate: 'from') + ' - ' + (visitPlan | bringozFullDate: 'to')"
              openDelay="300"
              triggers="hover"
              container="body">
          {{ visitPlan | bringozFullDate: 'from' }} - {{ visitPlan | bringozFullDate: 'to' }}
        </span>
      </div>

      <!--Service Time Provider-->
      <div class="td col-service-time-provider layout-row layout-align-start-center">
        <span *ngIf="visitPlan.visitPlanConfig?.visitSlotProviderTypeRegistry?.visitSlotServiceTimeProviderType?.[0] as serviceTimeProvider"
              class="text-ellipsis"
              [ngbTooltip]="'VISIT_SLOT_SERVICE_TIME_PROVIDERS.' + serviceTimeProvider | translate"
              openDelay="300"
              triggers="hover"
              container="body">
          {{ 'VISIT_SLOT_SERVICE_TIME_PROVIDERS.' + serviceTimeProvider | translate }}
        </span>
      </div>

      <!--Units Provider-->
      <div class="td col-units-provider layout-row layout-align-start-center">
        <span *ngIf="visitPlan.visitPlanConfig?.visitSlotProviderTypeRegistry?.visitSlotUnitsProviderType?.[0] as unitsProvider"
              class="text-ellipsis"
              [ngbTooltip]="'VISIT_SLOT_UNITS_PROVIDERS.' + unitsProvider | translate"
              openDelay="300"
              triggers="hover"
              container="body">
          {{ 'VISIT_SLOT_UNITS_PROVIDERS.' + unitsProvider | translate }}
        </span>
      </div>

      <!--Delivery Time Provider-->
      <div class="td col-delivery-time-provider layout-row layout-align-start-center">
        <span *ngIf="visitPlan.visitPlanConfig?.visitSlotProviderTypeRegistry?.visitSlotDeliveryTimeProviderType?.[0] as deliveryTimeProvider"
              class="text-ellipsis"
              [ngbTooltip]="'VISIT_SLOT_DELIVERY_TIME_PROVIDERS.' + deliveryTimeProvider | translate"
              openDelay="300"
              triggers="hover"
              container="body">
          {{ 'VISIT_SLOT_DELIVERY_TIME_PROVIDERS.' + deliveryTimeProvider | translate }}
        </span>
      </div>

      <!--Branches-->
      <div class="td col-branches layout-row layout-align-start-center">
        <branches-indicator *ngIf="visitPlan.branchReferences?.length"
                            [branches]="visitPlan.branchReferences">
        </branches-indicator>
      </div>

      <!--Created By-->
      <div class="td col-created-by layout-row layout-align-start-center">
        <span class="text-ellipsis"
              [ngbTooltip]="visitPlan.createdBy?.name"
              openDelay="300"
              triggers="hover"
              container="body">
          {{ visitPlan.createdBy?.name }}
        </span>
      </div>

    </div>
  </ng-template>

  <app-empty-state tableEmptyState
                   src="assets/images/empty_state/empty_state_location_box.svg"
                   text="No scheduling projects found">
  </app-empty-state>

</app-bringoz-data-table>
